import { render, staticRenderFns } from "./RegionsCreateEdit.vue?vue&type=template&id=091a1244&scoped=true"
import script from "./RegionsCreateEdit.vue?vue&type=script&lang=js"
export * from "./RegionsCreateEdit.vue?vue&type=script&lang=js"
import style0 from "./RegionsCreateEdit.vue?vue&type=style&index=0&id=091a1244&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091a1244",
  null
  
)

export default component.exports